import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "@mdi/font/css/materialdesignicons.css";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueSweetalert2);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDTvuisfH7eyVRBBYrZYTdaGhlOVb4LP9k",
    libraries: "places",
    region: "AR",
    languaje: "es",
  },
  installComponents: true,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
